import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { momentumActions, mediaActions } from '../../../../_actions';
import { Loader } from '../../../../_components';
import WebviewCustomization from './Webview.modal'
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import CreatableSelect from 'react-select/creatable';
import 'react-toastify/dist/ReactToastify.css';

const createOption = (label) => ({
  label,
  dischargeInArray: label,
});

class ChannelBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      availableChannels: [],
      selectedChannel: '',
      loading: true,
      empty: false,
      positionX: 0,
      positionY: 0,
      channelOption: '0',
      defaultMessage: true,
      tooltipIsOpen: false,
      showModal: false,
      media: [],
      mediaIsLoaded: false,
      selectedMedia: "",
      recurrency: false,
      intervalRecurrencyValue: "",
      intervalRecurrencyArray: [],
      dischargeIn: ""
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleModalShow = this.handleModalShow.bind(this);
    this.loadMediaFiles = this.loadMediaFiles.bind(this);
    this.handleAddImage = this.handleAddImage.bind(this);
    this.handleTypedImage = this.handleTypedImage.bind(this);
    this.handleRecurrency = this.handleRecurrency.bind(this);
    this.handleChangeDischarge = this.handleChangeDischarge.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const self = this;
    const cardData = this.props.cardData

    dispatch(momentumActions.listAvailableChannels(this.props.domain))
      .then(res => {
        if ( res.type === 'ALERT_FAILURE' ) return;
        if ( res.data.data.length === 0 ) return this.setState({loading: false, empty: true});

        self.setState({loading: false, empty: false, availableChannels: res.data.data});

        this.state.availableChannels.map((item) => {

          if (cardData && cardData.values[0].filter === item.channel_type) {
            sessionStorage.setItem('cell_selected_channel', item.uuid);
          }
          return item
        });
      })
      
    if (cardData) {
      const type = cardData.values[0];

      switch(type.filter) {
        case 'CELL_NOTIFICATION':
          this.setState({
            selectedChannel: type.filter,
            channelOption: type.filter,
            channelIconUri: type.icon_uri,
            channelMessage: type.message,
            channelName: type.name,
            channelRedirectUri: type.redirect_uri,
            channelTitle: type.title,
            channelImage: type.image
          });
          break;
        // case 'SUPERARE_NOTIFICATION':
        //   this.setState({
        //     selectedChannel: type.filter,
        //     channelOption: type.filter,
        //     channelIconUri: type.icon_uri,
        //     channelMessage: type.message,
        //     channelName: type.name,
        //     channelRedirectUri: type.redirect_uri,
        //     channelTitle: type.title,
        //     channelImage: type.image
        //   });
        //   break;
        case 'ZENVIA':
          this.setState({
            selectedChannel: type.filter,
            channelOption: type.filter,
            channelSmsMessage: type.body,
          });
          break;
        case 'AWS_SES':
          this.setState({
            selectedChannel: type.filter,
            channelOption: type.filter,
            channelBody: type.body,
            channelSubject: type.subject
          });
          break;
        case 'ONE_SIGNAL':
          this.setState({
            selectedChannel: type.filter,
            channelOption: type.filter,
            channelMessagePt: type.pt,
            channelMessageEn: type.en
          });
          break;
        case 'SUPERARE_WEBVIEW':
          this.setState({
            selectedChannel: type.filter,
            channelOption: type.filter,
            customizationOptions: type
          });
          break;
        case 'AKNA':
          this.setState({
            selectedChannel: type.filter,
            channelOption: type.filter,
            action_id: type.action_id,
            message_id: type.message_id,
            name_sender: type.name_sender,
            mail_sender: type.mail_sender,
            subject: type.subject,
            mail_return: type.mail_return
          });
          break;
        default:
          break;
      }

    }

    if (this.props.viewMode) return this.setState({viewMode: true});

    this.props.mobileOption ? this.setState({mobileOption: true}) : this.setState({mobileOption: false});
  }

  componentWillReceiveProps(newProps) {
    newProps.mobileOption ? this.setState({mobileOption: true}) : this.setState({mobileOption: false});
  }

  handleModal(e) {
    this.props.handleCustomize();
  }

  handleChange(e) {
    this.setState({channelOption: e.target.value});

    this.props.handleWebview(e.target.value);

    if ( e.target.name === 'channel-filter' ) {
      sessionStorage.setItem('cell_selected_channel', e.target.selectedOptions[0].getAttribute('data-uuid'));
      return this.setState({selectedChannel: e.target.value, selectedMedia: ""});
    }
  }

  handleModalShow(e) {
    let show = false;

    if ( e && e.target.getAttribute('data-modal-show') ) {
      show = true;
    }

    this.setState({showModal: show});
  }

  loadMediaFiles() {
    if ( this.state.mediaIsLoaded ) return;

    const { dispatch } = this.props;
    dispatch(mediaActions.listMediaByDomain(this.props.domain))
      .then(res => {
        if ( res.type === "LIST_MEDIA_FAILURE" ) return;
        this.setState({media: res.data.data, mediaIsLoaded: true});
      });
  }

  handleAddImage(e) {
    let attr = e.target.getAttribute('data-image');
    this.setState({selectedMedia: attr, showModal: false});
  }

  handleTypedImage(e) {
    let val = e.target.value;
    this.setState({selectedMedia: val});
  }
  
  handleRecurrency() {
    this.setState({recurrency: true});
  }

  handleChangeDischarge(e, dischargeInArray) {
    if ( dischargeInArray.action === 'remove-value' ) {
      let newDischargeInArray = [...this.state.intervalRecurrencyArray];

      newDischargeInArray = newDischargeInArray.filter(element => {
        return element.dischargeInArray !== dischargeInArray.removedValue.dischargeInArray
      })

      this.setState({intervalRecurrencyArray: newDischargeInArray});
    } else {
      this.setState({intervalRecurrencyArray: []});
    }
  }

  handleInputChange(dischargeInValue) {
    this.setState({ intervalRecurrencyValue: dischargeInValue });
  }

  handleKeyDown(e) {
    const { intervalRecurrencyValue, intervalRecurrencyArray, dischargeIn } = this.state;

    if (!intervalRecurrencyValue) return;

    let key = e.key;

    if (e.nativeEvent.type === 'blur')
      key = 'blur';

    switch (key) {
      case ';':
      case 'Enter':
      case 'Tab':
      case 'blur':
        let arr = [];
        arr.push(intervalRecurrencyValue);

        this.setState({
          intervalRecurrencyValue: '',
          intervalRecurrencyArray: [...intervalRecurrencyArray, createOption(intervalRecurrencyValue)],
        });

        intervalRecurrencyArray.map(items => {
          arr.push(items.intervalRecurrencyArray);
        });

        arr.sort((a, b) => a - b);

        let intervalRecurrencyValues = intervalRecurrencyValue.split(' ');
        let resultado = 0;
        let resultados = !this.state.dischargeIn ? [] : this.state.dischargeIn;
        intervalRecurrencyValues.map(async values => {
          let multipliers = {
            "A": 31536000,
            "M": 2592000,
            "D": 86400,
            "h": 3600,
            "m": 60,
            "s": 1
          }

          let regex = values.match(/[a-z]+|[^a-z]+/gi);
          let value = regex[0];
          let multiplier = multipliers[regex[1]];
          let totalSeconds = multiplier * value;

          if ( !multiplier ) multiplier = "Não foi possível definir um valor. Reescreva seu intervalo.";

          resultado = resultado + totalSeconds;
        })

        if ( isNaN(resultado) ) return;

        resultados.push(resultado);
        this.setState({dischargeIn: resultados});

        e.preventDefault();
        break;
      default:
       break;
    }
  };

  render() {
    let { selectedChannel, tooltipIsOpen, modalIsOpen } = this.state;

    const Components = {
      // 'SUPERARE_NOTIFICATION': <SuperareInputs data={this.state} showModal={this.handleModalShow} selectedImage={this.state.selectedMedia} />,
      'CELL_NOTIFICATION': <CellInputs data={this.state} showModal={this.handleModalShow} selectedImage={this.state.selectedMedia} />,
      'ZENVIA': <ZenviaInputs data={this.state} />,
      'AWS_SES': <AwsInputs data={this.state} />,
      'ONE_SIGNAL': <OneSignalInputs data={this.state} showModal={this.handleModalShow} selectedImage={this.state.selectedMedia} />,
      'SUPERARE_WEBVIEW': <WebviewCustomization data={this.state} handleCustomize={this.handleModal} showModal={this.handleModalShow} selectedImage={this.state.selectedMedia} />,
      'AKNA': <AknaInputs data={this.state} />
    }
    
    const channelNameTranslate = {
      "CELL_NOTIFICATION": "Cell",
      // "SUPERARE_NOTIFICATION": "Superare",
      "ZENVIA": "Zenvia",
      "AWS_SES": "AmazonSES",
      "ONE_SIGNAL": "OneSignal",
      "SUPERARE_WEBVIEW": "Webview",
      "AKNA": "Akna" 
    }

    return(
      <>
        <div className={`block channel-block channel-block-component channel-block-type-${this.state.selectedChannel.toLowerCase()}`} style={{zIndex: modalIsOpen ? '99999' : '19'}}>
          <input type="hidden" name="channel-type" id="channel-type" defaultValue="dispatcher"/>

          <div className="custom-tooltip">
            <a href="#" className={`custom-tooltip-link ${tooltipIsOpen ? 'active' : ''}`} onClick={() => tooltipIsOpen ? this.setState({tooltipIsOpen: false}) : this.setState({tooltipIsOpen: true})}>
              <span>?</span>
              
              <div className="custom-tooltip-card">
                <p>Por onde suas notificações devem ser enviadas e qual a mensagem será programada.</p>
              </div>
            </a>
          </div>

          <p className="block-title">Canal</p>
          {
            !this.state.loading && !this.state.empty ?
              <div className="select-group">
                <select name="channel-filter" id="channel-filter" className="form-control" value={this.state.channelOption} onChange={this.handleChange} required disabled={this.state.viewMode}>
                  <option value="0" disabled>Selecione uma opção</option>
                  {
                    this.state.availableChannels ?
                      this.state.availableChannels.map((channel, index) => {
                        if ( channel.channel_type === "SUPERARE_NOTIFICATION") return;
                        let channelName = channelNameTranslate[channel.channel_type];
                        return <option key={index} value={channel.channel_type} data-uuid={channel.uuid}>{channelName}</option>
                      }
                    ) : ""
                  }
                </select>
              </div>
            : this.state.empty ?
              <div>
                <p className="block-disclaimer">Seu domínio não possui canais integrados. Integre um canal antes de concluir a criação do seu momentum.</p>
                <Link to="/channels" className="btn btn-white btn-block">Integrar canais</Link>
              </div>
            : <Loader className="in-block" /> 
          }
          <br/>

          {
            this.state.selectedChannel ?
              <>
                {Components[selectedChannel]}
                
                <div className="form-check">
                  <input name="allow-more-submits" id="allow-more-submits" type="checkbox" onChange={this.handleRecurrency}/>
                  <label htmlFor="allow-more-submits">Permitir mais de um envio</label>
                </div>

                {
                  this.state.recurrency ?
                    <span>
                      <p className="block-title" style={{marginTop: '15px'}}>Intervalo de notificação:</p>
                      <input type="hidden" value={this.state.dischargeIn} name="channel-intervalRecurrency" id="channel-intervalRecurrency"/>
                      <CreatableSelect
                        components={{DropdownIndicator: null}}
                        inputValue={this.state.intervalRecurrencyValue}
                        menuIsOpen={false}
                        isClearable
                        onChange={this.handleChangeDischarge}
                        onInputChange={this.handleInputChange}
                        onKeyDown={this.handleKeyDown}
                        onBlur={this.handleKeyDown}
                        isDisabled={this.props.viewMode}
                        placeholder="Ex.: 1D 4h 30m (1 dia, 4 horas e 30 minutos)"
                        value={this.state.intervalRecurrencyArray}
                      />
                      <label htmlFor="channel-intervalRecurrency" style={{color: "#fff", fontSize: "0.8rem", marginTop: "10px"}}>Obs: O numeral deve ser seguido por uma das letras a seguir: A (ano), M (mês), D (dia), h (hora), m (minuto) e s (segundo).</label>
                    </span>
                  : null
                }
              </>
            : ''
          }
        </div>

        <Modal
          className="custom-card-modal"
          size="lg"
          centered
          show={this.state.showModal}
          onHide={this.handleModalShow}
          onEntered={this.loadMediaFiles}
        >
          <Modal.Body>
            <p className="custom-modal-title">Informe uma URL abaixo</p>
            <div className="input-group mb-3">
              <input name="channel-image" id="channel-image" type="text" className="form-control" value={this.props.selectedImage} onChange={this.handleTypedImage} placeholder="Ex.: https://url.com/path/imagem"/>
              <div className="input-group-prepend">
                <button type="button" className="btn btn-icon btn-outline-secondary" onClick={this.handleModalShow}>
                  SALVAR
                </button>
              </div>
            </div>

            <p className="custom-modal-title">ou selecione uma de suas mídias:</p>

            {
              !this.state.mediaIsLoaded ?
                <Loader className="is-blue"/>
              : <div className="media-group">
                {
                  this.state.media ?
                    this.state.media.map(data => {
                      return <a href="#" data-image={data.image} onClick={this.handleAddImage}>
                        <img src={data.image} key={data.image} />
                      </a>
                    })
                  : null
                }
              </div>
            }
          </Modal.Body>
        </Modal>
      </>
    )
  }
}

class SuperareInputs extends Component {

  constructor(props) {
    super(props);

    this.state = {
      count: 80,
      countTitle: 25,
      channelIconUri: this.props.data.channelIconUri ? this.props.data.channelIconUri : '',
      channelMessage: this.props.data.channelMessage ? this.props.data.channelMessage : '',
      channelName: this.props.data.channelName ? this.props.data.channelName : '',
      channelRedirectUri: this.props.data.channelRedirectUri ? this.props.data.channelRedirectUri : '',
      channelTitle: this.props.data.channelTitle ? this.props.data.channelTitle : '',
      channelImage: this.props.data.channelImage ? this.props.data.channelImage : ''
    }

    this.handleChannelIconUri = this.handleChannelIconUri.bind(this);
    this.handleChannelMessage = this.handleChannelMessage.bind(this);
    this.handleChannelName = this.handleChannelName.bind(this);
    this.handleChannelRedirectUri = this.handleChannelRedirectUri.bind(this);
    this.handleChannelTitle = this.handleChannelTitle.bind(this);
    this.handleChannelImageRemoval = this.handleChannelImageRemoval.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if ( !nextProps.selectedImage ) return;
    if ( nextProps.selectedImage === this.state.channelImage ) return;

    this.setState({channelImage: nextProps.selectedImage});
  }

  handleChannelName(e) {
    this.setState({
      channelName: e.target.value
    });
  }

  handleChannelIconUri(e) {
    this.setState({
      channelIconUri: e.target.value
    });
  }

  handleChannelMessage(e) {
    this.setState({
      channelMessage: e.target.value,
      count: 80 - e.target.value.length
    });
  }

  handleChannelRedirectUri(e) {
    this.setState({
      channelRedirectUri: e.target.value
    });
  }

  handleChannelTitle(e) {
    this.setState({
      channelTitle: e.target.value,
      countTitle: 25 - e.target.value.length
    });
  }

  handleTestNotification = e => {
    const title = this.state.channelTitle;

    const options = {
      body: this.state.channelMessage,
      image: this.props.selectedImage,
      icon: this.state.channelIconUri,
      url: this.state.channelRedirectUri
    }

    if (!this.state.channelTitle) {
      toast.warning('A notificação precisa ter um título', {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-warning'
      });

      return false;
    };

    Notification.requestPermission(function (permission) {
      if (!("Notification" in window)) {
        toast.error('Este browser não suporta notificações de Desktop', {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      }
    
      else if (Notification.permission === "granted") {
        const notification = new Notification(title, options);

        notification.onclick = function(event) {
          event.preventDefault();
          window.open(options.url, '_blank');
        }
      }
    
      else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            new Notification(title, options);
          }
        });
      }
    });
  }

  handleChannelImageRemoval() {
    this.setState({channelImage: ""});
  }

  render() {
    return (
      <div>
        
        <p className="block-title">Notificação</p>
        <input name="channel-name" id="channel-name" type="text" className="form-control" value={this.state.channelName} onChange={this.handleChannelName} placeholder="Nome" required readOnly={this.props.data.viewMode}/>

        <div className="title-input-group">
          <input name="channel-title" id="channel-title" type="text" maxLength="25" className="form-control" value={this.state.channelTitle} onChange={this.handleChannelTitle} placeholder="Título" required readOnly={this.props.data.viewMode}/>

          <span className="count">{this.state.channelTitle.length} / 25</span>
          <span
            className={`progressbar
              ${(this.state.channelTitle.length < (25 / 2)) ? 'progressbar-blue' : 'progressbar-yellow'}
              ${(this.state.channelTitle.length >= 20) ? 'progressbar-red' : ''}`
            }
            style={{width: `calc(${this.state.channelTitle.length}% * 4)` }}
          ></span>
        </div>

        <div className="textarea-group">
          <textarea name="channel-message" id="channel-message" type="text" maxLength="80" className="form-control" value={this.state.channelMessage} onChange={this.handleChannelMessage} placeholder="Mensagem" style={{resize: 'none'}} required readOnly={this.props.data.viewMode}></textarea>

          <span className="count">{this.state.channelMessage.length} / 80</span>
          <span
            className={`progressbar
              ${(this.state.channelMessage.length < (80 / 2)) ? 'progressbar-blue' : 'progressbar-yellow'}
              ${(this.state.channelMessage.length >= 70) ? 'progressbar-red' : ''}`
            }
            style={{width: `calc(${this.state.channelMessage.length}% * 1.25)` }}
          ></span>
        </div>
        
        <div className="input-group mb-3">
          {
            this.state.channelImage !== "" ?
              <div className="input-group-prepend">
                <button type="button" className="btn btn-icon btn-red" onClick={this.handleChannelImageRemoval}>
                  <i className="linearicons-cross"></i>
                </button>
              </div>
            : <div className="input-group-prepend">
                <button type="button" className="btn btn-icon btn-outline-secondary" onClick={this.props.showModal} data-modal-show="true">
                  <i className="linearicons-file-image"></i> 
                </button>
              </div>
          }
          <input name="channel-image" id="channel-image" type="text" className="form-control" value={this.state.channelImage} placeholder="URL da Imagem" readOnly disabled/>
        </div>

        <input name="channel-icon_uri" id="channel-icon_uri" type="text" className="form-control" value={this.state.channelIconUri} onChange={this.handleChannelIconUri} placeholder="URL do Ícone" required readOnly={this.props.data.viewMode}/>
        <input name="channel-redirect_uri" id="channel-redirect_uri" type="text" className="form-control mb-3" value={this.state.channelRedirectUri} onChange={this.handleChannelRedirectUri} placeholder="URL de Redirecionamento" required readOnly={this.props.data.viewMode}/>

        <div className="input-group">
          <button type="button" className="btn btn-icon btn-white btn-test-notification" onClick={this.handleTestNotification}>
            <i className="linearicons-play-circle"></i> Testar notificação 
          </button>
        </div>
      </div>
    )
  }
}

class CellInputs extends Component {

  constructor(props) {
    super(props);

    this.state = {
      count: 80,
      countTitle: 25,
      channelIconUri: this.props.data.channelIconUri ? this.props.data.channelIconUri : '',
      channelMessage: this.props.data.channelMessage ? this.props.data.channelMessage : '',
      channelName: this.props.data.channelName ? this.props.data.channelName : '',
      channelRedirectUri: this.props.data.channelRedirectUri ? this.props.data.channelRedirectUri : '',
      channelTitle: this.props.data.channelTitle ? this.props.data.channelTitle : '',
      channelImage: this.props.data.channelImage ? this.props.data.channelImage : ''
    }

    this.handleChannelIconUri = this.handleChannelIconUri.bind(this);
    this.handleChannelMessage = this.handleChannelMessage.bind(this);
    this.handleChannelName = this.handleChannelName.bind(this);
    this.handleChannelRedirectUri = this.handleChannelRedirectUri.bind(this);
    this.handleChannelTitle = this.handleChannelTitle.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if ( !nextProps.selectedImage ) return;
    if ( nextProps.selectedImage === this.state.channelImage ) return;

    this.setState({channelImage: nextProps.selectedImage});
  }

  handleChannelName(e) {
    this.setState({
      channelName: e.target.value
    });
  }

  handleChannelIconUri(e) {
    this.setState({
      channelIconUri: e.target.value
    });
  }

  handleChannelMessage(e) {
    this.setState({
      channelMessage: e.target.value,
      count: 80 - e.target.value.length
    });
  }

  handleChannelRedirectUri(e) {
    this.setState({
      channelRedirectUri: e.target.value
    });
  }

  handleChannelTitle(e) {
    this.setState({
      channelTitle: e.target.value,
      countTitle: 25 - e.target.value.length
    });
  }

  handleTestNotification = e => {
    const title = this.state.channelTitle;

    const options = {
      body: this.state.channelMessage,
      image: this.props.selectedImage,
      icon: this.state.channelIconUri,
      url: this.state.channelRedirectUri
    }

    if (!this.state.channelTitle) {
      toast.warning('A notificação precisa ter um título', {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-warning'
      });

      return false;
    };

    Notification.requestPermission(function (permission) {
      if (!("Notification" in window)) {
        toast.error('Este browser não suporta notificações de Desktop', {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      }
    
      else if (Notification.permission === "granted") {
        const notification = new Notification(title, options);

        notification.onclick = function(event) {
          event.preventDefault();
          window.open(options.url, '_blank');
        }
      }
    
      else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            new Notification(title, options);
          }
        });
      }
    });
  }

  render() {
    return (
      <div>
        <p className="block-title">Notificação</p>
        <input name="channel-name" id="channel-name" type="text" className="form-control" value={this.state.channelName} onChange={this.handleChannelName} placeholder="Nome" required readOnly={this.props.data.viewMode}/>

        <div className="title-input-group">
          <input name="channel-title" id="channel-title" type="text" maxLength="25" className="form-control" value={this.state.channelTitle} onChange={this.handleChannelTitle} placeholder="Título" required readOnly={this.props.data.viewMode}/>

          <span className="count">{this.state.channelTitle.length} / 25</span>
          <span
            className={`progressbar
              ${(this.state.channelTitle.length < (25 / 2)) ? 'progressbar-blue' : 'progressbar-yellow'}
              ${(this.state.channelTitle.length >= 20) ? 'progressbar-red' : ''}`
            }
            style={{width: `calc(${this.state.channelTitle.length}% * 4)` }}
          ></span>
        </div>

        <div className="textarea-group">
          <textarea name="channel-message" id="channel-message" type="text" maxLength="80" className="form-control" value={this.state.channelMessage} onChange={this.handleChannelMessage} placeholder="Mensagem" style={{resize: 'none'}} required readOnly={this.props.data.viewMode}></textarea>

          <span className="count">{this.state.channelMessage.length} / 80</span>
          <span
            className={`progressbar
              ${(this.state.channelMessage.length < (80 / 2)) ? 'progressbar-blue' : 'progressbar-yellow'}
              ${(this.state.channelMessage.length >= 70) ? 'progressbar-red' : ''}`
            }
            style={{width: `calc(${this.state.channelMessage.length}% * 1.25)` }}
          ></span>
        </div>
        
        <div className="input-group mb-3">
          <div className="input-group-prepend">
            <button type="button" className="btn btn-icon btn-outline-secondary" onClick={this.props.showModal} data-modal-show="true">
              <i className="linearicons-file-image"></i> 
            </button>
          </div>
          <input name="channel-image" id="channel-image" type="text" className="form-control" value={this.state.channelImage} placeholder="URL da Imagem" readOnly disabled/>
        </div>

        <input name="channel-icon_uri" id="channel-icon_uri" type="text" className="form-control" value={this.state.channelIconUri} onChange={this.handleChannelIconUri} placeholder="URL do Ícone" required readOnly={this.props.data.viewMode}/>
        <input name="channel-redirect_uri" id="channel-redirect_uri" type="text" className="form-control mb-3" value={this.state.channelRedirectUri} onChange={this.handleChannelRedirectUri} placeholder="URL de Redirecionamento" required readOnly={this.props.data.viewMode}/>

        <div className="input-group">
          <button type="button" className="btn btn-icon btn-white btn-test-notification" onClick={this.handleTestNotification}>
            <i className="linearicons-play-circle"></i> Testar notificação 
          </button>
        </div>
      </div>
    )
  }
}

class ZenviaInputs extends Component {

  constructor(props) {
    super(props);

    this.state = {
      channelSmsMessage: this.props.data.channelSmsMessage ? this.props.data.channelSmsMessage : ''
    }

    this.handleChannelSmsMessage = this.handleChannelSmsMessage.bind(this);

  }

  handleChannelSmsMessage(e) {
    this.setState({
      channelSmsMessage: e.target.value
    });
  }

  render() {
    return (
      <div>
        <p className="block-title">SMS</p>
        <textarea name="channel-body" id="channel-body" className="form-control" value={this.state.channelSmsMessage} onChange={this.handleChannelSmsMessage} placeholder="Mensagem" style={{resize: 'none'}} required readOnly={this.props.data.viewMode}></textarea>
      </div>
    )
  }
}

class AwsInputs extends Component {

  constructor(props) {
    super(props);

    this.state = {
      channelBody: this.props.data.channelBody ? this.props.data.channelBody : '',
      channelSubject: this.props.data.channelSubject ? this.props.data.channelSubject : '',
    }

    this.handleChannelBody = this.handleChannelBody.bind(this);
    this.handleChannelSubject = this.handleChannelSubject.bind(this);

  }

  handleChannelBody(e) {
    this.setState({
      channelBody: e.target.value
    });
  }

  handleChannelSubject(e) {
    this.setState({
      channelSubject: e.target.value
    });
  }

  render() {
    return (
      <div>
        <p className="block-title">E-mail</p>
        <input type="text" name="channel-subject" id="channel-subject" className="form-control" value={this.state.channelBody} onChange={this.handleChannelBody} placeholder="Título" required readOnly={this.props.data.viewMode}/>
        <textarea name="channel-body" id="channel-body" className="form-control" value={this.state.channelSubject} onChange={this.handleChannelSubject} placeholder="Mensagem" style={{resize: 'none'}} required readOnly={this.props.data.viewMode}></textarea>
      </div>
    )
  }
}

class OneSignalInputs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      channelTitle: this.props.data.channelTitle ? this.props.data.channelTitle : '',
      channelUrl: this.props.data.channelUrl ? this.props.data.channelUrl : '',
      channelMessagePt: this.props.data.channelMessagePt ? this.props.data.channelMessagePt : '',
      channelMessageEn: this.props.data.channelMessageEn ? this.props.data.channelMessageEn : '',
    }

    this.handleChannelTitle = this.handleChannelTitle.bind(this);
    this.handleChannelUrl = this.handleChannelUrl.bind(this);
    this.handleChannelMessagePt = this.handleChannelMessagePt.bind(this);
    this.handleChannelMessageEn = this.handleChannelMessageEn.bind(this);
  }

  handleChannelTitle(e) { this.setState({ channelTitle: e.target.value }); }
  handleChannelUrl(e) { this.setState({ channelUrl: e.target.value }); }
  handleChannelMessagePt(e) { this.setState({ channelMessagePt: e.target.value }); }
  handleChannelMessageEn(e) { this.setState({ channelMessageEn: e.target.value }); }

  handleTestNotificationPT = e => {
    const title = this.state.channelTitle;

    const optionsPt = {
      body: this.state.channelMessagePt,
      image: this.props.selectedImage,
      url: this.state.channelUrl
    }

    if (!this.state.channelTitle) {
      toast.warning('A notificação precisa ter um título', {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-warning'
      });

      return false;
    };

    Notification.requestPermission(function (permission) {
      if (!("Notification" in window)) {
        toast.error('Este browser não suporta notificações de Desktop', {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      }
    
      else if (Notification.permission === "granted") {
        const notificationPt = new Notification(title, optionsPt);

        notificationPt.onclick = function(event) {
          event.preventDefault();
          window.open(optionsPt.url, '_blank');
        }
      }
    
      else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            new Notification(title, optionsPt);
          }
        });
      }
    });
  }

  handleTestNotificationEN = e => {
    const title = this.state.channelTitle;

    const optionsEn = {
      body: this.state.channelMessageEn,
      image: this.props.selectedImage,
      url: this.state.channelUrl
    }

    if (!this.state.channelTitle) {
      toast.warning('A notificação precisa ter um título', {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast-warning'
      });

      return false;
    };

    Notification.requestPermission(function (permission) {
      if (!("Notification" in window)) {
        toast.error('Este browser não suporta notificações de Desktop', {
          position: toast.POSITION.TOP_RIGHT,
          className: 'toast-error'
        });
      }
    
      else if (Notification.permission === "granted") {
        const notificationEn = new Notification(title, optionsEn);

        notificationEn.onclick = function(event) {
          event.preventDefault();
          window.open(optionsEn.url, '_blank');
        }
      }
    
      else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          if (permission === "granted") {
            new Notification(title, optionsEn);
          }
        });
      }
    });
  }

  render() {
    return (
      <div>
        <p className="block-title">Notificação</p>
        <input type="text" name="channel-title" id="channel-title" className="form-control" placeholder="Título" value={this.state.channelTitle} onChange={this.handleChannelTitle}/>
        <input type="text" name="channel-title" id="channel-title" className="form-control" placeholder="URL de Redirecionamento" value={this.state.channelUrl} onChange={this.handleChannelUrl}/>
        <div className="input-group mb-3">
          <div className="input-group-prepend">
            <button type="button" className="btn btn-icon btn-outline-secondary" onClick={this.props.showModal} data-modal-show="true">
              <i className="linearicons-file-image"></i> 
            </button>
          </div>
          <input name="channel-chrome_web_image" id="channel-chrome_web_image" type="text" className="form-control" value={this.props.selectedImage} placeholder="URL da Imagem" readOnly disabled/>
        </div>
        <textarea type="text" name="channel-pt" id="channel-pt" className="form-control" value={this.state.channelMessagePt} onChange={this.handleChannelMessagePt} placeholder="Mensagem (Português)" style={{resize: 'none'}} required readOnly={this.props.data.viewMode}></textarea>
        <textarea type="text" name="channel-en" id="channel-en" className="form-control" value={this.state.channelMessageEn} onChange={this.handleChannelMessageEn} placeholder="Mensagem (Inglês)" style={{resize: 'none'}} required readOnly={this.props.data.viewMode}></textarea>

        <div className="input-group">
          <button type="button" className="btn btn-icon btn-white btn-test-notification" onClick={this.handleTestNotificationPT}>
            <i className="linearicons-play-circle"></i> Testar notificação (pt-BR)
          </button>
        </div>
        <div className="input-group">
          <button type="button" className="btn btn-icon btn-white btn-test-notification" onClick={this.handleTestNotificationEN}>
            <i className="linearicons-play-circle"></i> Testar notificação (en-US)
          </button>
        </div>
      </div>
    )
  }
}

class AknaInputs extends Component {

  constructor(props) {
    super(props);

    this.state = {
      action_id: '',
      message_id: '',
      name_sender: '',
      mail_sender: '',
      subject: '',
      mail_return: ''
    }
  }

  componentWillReceiveProps() {
    const data = this.props.data;

    this.setState({
      action_id: data.action_id,
      message_id: data.message_id,
      name_sender: data.name_sender,
      mail_sender: data.mail_sender,
      subject: data.subject,
      mail_return: data.mail_return
    });
  }

  handleChange = e => {
    const name = e.target.getAttribute('id');
    const value = e.target.value;

    this.setState({[name]: value});
  }

  render() {
    return (
      <div>
        <p className="block-title">Configuração</p>
        <input name="channel-action_id" id="action_id" type="text" className="form-control" value={this.state.action_id} onChange={this.handleChange} placeholder="Código da ação" readOnly={this.props.data.viewMode} required/>
        <input name="channel-message_id" id="message_id" type="text" className="form-control" value={this.state.message_id} onChange={this.handleChange} placeholder="Código da mensagem" readOnly={this.props.data.viewMode} required/>
        <input name="channel-name_sender" id="name_sender" type="text" className="form-control" value={this.state.name_sender} onChange={this.handleChange} placeholder="Nome do remetente" readOnly={this.props.data.viewMode} required/>
        <input name="channel-mail_sender" id="mail_sender" type="text" className="form-control" value={this.state.mail_sender} onChange={this.handleChange} placeholder="Email do remetente" readOnly={this.props.data.viewMode} required/>
        <input name="channel-subject" id="subject" type="text" className="form-control" value={this.state.subject} onChange={this.handleChange} placeholder="Título do email" readOnly={this.props.data.viewMode} required/>
        <input name="channel-mail_return" id="mail_return" type="text" className="form-control" value={this.state.mail_return} onChange={this.handleChange} placeholder="Email de retorno" readOnly={this.props.data.viewMode}/>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { listedChannels } = state.listChannelsReducer;
  return listedChannels;
}

const ConnectedChannelsMomentumBlock = connect(mapStateToProps)(ChannelBlock);
export { ConnectedChannelsMomentumBlock as Channel }